import React, { useEffect } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { formatTime, prepareChartData, chartOptions } from '../../../utils/statsUtils';

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function StatPanel({ title, stats, isUpdating }) {
  useEffect(() => {
    ChartJS.register(
      CategoryScale,
      LinearScale,
      PointElement,
      LineElement,
      Title,
      Tooltip,
      Legend
    );
  }, []);

  if (!stats) {
    return (
      <div className="stat-panel">
        <h3>{title}</h3>
        <div className="stat-panel-content">
          <p>No data available</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`stat-panel ${isUpdating ? 'updating' : ''}`}>
      <h3>{title}</h3>
      <div className="stat-grid">
        <div className="stat-row header">
          <div>Metric</div>
          <div>Current</div>
          <div>Best</div>
        </div>
        
        <div className="stat-row">
          <div>Time</div>
          <div>{formatTime(stats.lastTime)}</div>
          <div>{formatTime(stats.fastestTime)}</div>
        </div>
        
        <div className="stat-row">
          <div>Ao5</div>
          <div>{formatTime(stats.rollingAverage5)}</div>
          <div>{formatTime(stats.bestAo5)}</div>
        </div>
        
        <div className="stat-row">
          <div>Ao12</div>
          <div>{formatTime(stats.rollingAverage12)}</div>
          <div>{formatTime(stats.bestAo12)}</div>
        </div>
      </div>
      
      <div className="stat-chart">
        {stats.times?.length > 0 && (
          <Line 
            data={prepareChartData(stats.times)}
            options={chartOptions}
            key={`${title}-${stats.times.length}`}
          />
        )}
      </div>
    </div>
  );
}

export default React.memo(StatPanel); 